var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvas_wrapper",attrs:{"id":"canvas_wrapper"}},[_c('canvas',{ref:"canvas",attrs:{"id":"canvas","height":"1000px","width":"1000px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }